import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { ReactSwitch } from "../../components/switches/dropdown-section";
import { NavBar } from "../../components/nav";
import { AnimatedDropList } from "../../components/drop-downs/drop-list/droplist";
import { HoverAnimButton } from "../../components/buttons/hover-anim";
import { HoverHint } from "../../components/hover-hint/hint";
import { MultipleSelect } from "../../components/drop-downs/select-lists/multiselect";
import { Header } from "../../components/header/header";

export const Playground = () => {
    return (
        <div className="page-body">
            <Header />
            <NavBar />
            <ReactSwitch
                switchedIcon={faEye}
                unswitchedIcon={faEyeSlash}
                switchedColor= "#afe6a9"
                unswitchedColor= "#ffffff" 
            />
            <div className="rw-cnt">
                <AnimatedDropList />
                <HoverHint caption={"Input your phone number so we can get back to you"}/>
            </div>
            
            <div className="rw-cnt">
                <HoverAnimButton />
                <HoverHint caption={"Hover to see animated button color effect!"}/>
            </div>

            <div className="rw-cnt">
                <MultipleSelect />
                <HoverHint caption={"Multiple select list demo!"}/>
            </div>
            
        </div>
    );
}